const getFiniteOrder = (value, fallback) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const moveItem = (array, fromIndex, toIndex) => {
  if (!Array.isArray(array)) return [];

  const next = [...array];
  const hasValidFrom = fromIndex >= 0 && fromIndex < next.length;
  const hasValidTo = toIndex >= 0 && toIndex < next.length;

  if (!hasValidFrom || !hasValidTo || fromIndex === toIndex) {
    return next;
  }

  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);
  return next;
};

export const buildOrderedIds = (workouts) => {
  if (!Array.isArray(workouts) || workouts.length === 0) return [];

  return workouts
    .map((workout, index) => ({
      id: workout?.id == null ? null : String(workout.id),
      index,
      order: getFiniteOrder(workout?.order, index),
    }))
    .filter((entry) => entry.id != null)
    .sort((a, b) => a.order - b.order || a.index - b.index)
    .map((entry) => entry.id);
};

export const commitWorkoutLibraryOrder = ({ coach, orderedIds }) => {
  if (!coach || !Array.isArray(orderedIds) || orderedIds.length === 0) {
    return false;
  }

  const workouts = Array.isArray(coach.workoutLibrary) ? coach.workoutLibrary : [];
  if (workouts.length === 0) return false;

  const workoutById = new Map(
    workouts.map((workout) => [String(workout?.id ?? "").toLowerCase(), workout]),
  );
  const seen = new Set();
  const knownOrderedWorkouts = orderedIds
    .map((id) => (id == null ? null : String(id).toLowerCase()))
    .map((normalizedId) => {
      if (!normalizedId || seen.has(normalizedId)) return null;
      seen.add(normalizedId);
      return workoutById.get(normalizedId) ?? null;
    })
    .filter(Boolean);

  let hasChanges = false;

  knownOrderedWorkouts.forEach((workout, index) => {
    const normalizedId = String(workout?.id ?? "").toLowerCase();
    const currentOrder = getFiniteOrder(workout?.order, -1);
    if (currentOrder === index) return;

    if (typeof workout?.setProperty === "function") {
      workout.setProperty("order", index);
    } else {
      workout.order = index;
    }

    coach?.updateCoachTransactionWorkouts?.(normalizedId);
    hasChanges = true;
  });

  if (hasChanges) {
    coach?.startOrResetBatchTimer?.();
  }

  return hasChanges;
};
